/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Preview_Property_HintInputs */

const cs_builder_preview_property_hint = /** @type {(inputs: Builder_Preview_Property_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volitelné. Zkompilovat proti skutečnému inzerátu místo ukázkových hodnot.`)
};

const en_builder_preview_property_hint = /** @type {(inputs: Builder_Preview_Property_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional. Compile against a real listing instead of sample values.`)
};

/**
* | output |
* | --- |
* | "Optional. Compile against a real listing instead of sample values." |
*
* @param {Builder_Preview_Property_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_preview_property_hint = /** @type {((inputs?: Builder_Preview_Property_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Preview_Property_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_preview_property_hint(inputs)
	return cs_builder_preview_property_hint(inputs)
});